import { Navigate, RouteObject, useRoutes } from 'react-router-dom';
import InjectionManagement from './InjectionManagement';

const InjectionManagementLayout: RouteObject[] = [
  {
    path: '/',
    element: (
      <InjectionManagement />
    ),
  },
  { path: '*', element: <Navigate to="/404" /> },
];

const InjectionManagementRoutes = () => useRoutes(InjectionManagementLayout);
export default InjectionManagementRoutes;
